/* TODO: t() */
import React from 'react';
import {
  VendorProfileTemplate,
  ProfileSettings,
} from '../../../types/shared/Account';

import { VendorSummaryWithMarketsAndFields } from '../../../types/shared/Vendor';
import getColorString from '../../../support/helpers/getColorString';
import { BLACK_RGB_COLOR, WHITE_RGB_COLOR } from '../../uiold/Constants';
import CardBase from '../Cards/CardBase';
import { StyleSheet, css } from 'aphrodite';

type Props = {
  title?: string | null | undefined;
  vendors: Array<VendorSummaryWithMarketsAndFields>;
  onProfileSelect: (vendorID: string) => void;
  renderEmptyState?: () => React.ReactNode;
  vendorProfileTemplate?: VendorProfileTemplate;
  accountID?: string;
  profiles?: ProfileSettings;
};

function ProfileList(props: Props) {
  let {
    title,
    vendors,
    onProfileSelect,
    renderEmptyState,
    vendorProfileTemplate,
    accountID,
    profiles,
  } = props;
  let listItems = vendors.map((vendor) => {
    let onClick = () => onProfileSelect(vendor.id);
    if (
      vendorProfileTemplate?.type &&
      vendorProfileTemplate?.type !== 'noTemplate' &&
      accountID
    ) {
      return (
        <div key={vendor.id} className={css(styles.card)}>
          <CardBase
            vendorID={vendor.id}
            vendorData={vendor}
            accountID={accountID}
            selectedNameID={vendorProfileTemplate.nameID ?? ''}
            selectedImageID={vendorProfileTemplate.imageID ?? ''}
            selectedDescriptionID={vendorProfileTemplate.descriptionID ?? ''}
            selectedCardOptionType={vendorProfileTemplate.type}
            onClick={onClick}
            nameColor={getColorString(
              vendorProfileTemplate?.nameColor ?? BLACK_RGB_COLOR,
            )}
            descriptionColor={getColorString(
              vendorProfileTemplate?.descriptionColor ?? BLACK_RGB_COLOR,
            )}
            backgroundColor={getColorString(
              vendorProfileTemplate?.backgroundColor ?? WHITE_RGB_COLOR,
            )}
          />
        </div>
      );
    } else {
      return (
        <div key={vendor.id} className="list-item" onClick={onClick}>
          <div className="vender-name">{vendor.name}</div>
        </div>
      );
    }
  });
  return (
    <div
      className="vendor-profiles vendor-list"
      style={{
        backgroundColor: profiles?.backgroundColor
          ? getColorString(profiles.backgroundColor)
          : '',
      }}
    >
      {title ? <h3 className={css(styles.title)}>{title}</h3> : null}
      {vendorProfileTemplate?.type &&
      vendorProfileTemplate?.type !== 'noTemplate' ? (
        <div className={css(styles.cardContainer)}>
          {vendors.length === 0 && renderEmptyState
            ? renderEmptyState()
            : listItems}
        </div>
      ) : (
        <>
          {vendors.length === 0 && renderEmptyState
            ? renderEmptyState()
            : listItems}
        </>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  card: {
    margin: 14,
  },
  title: {
    marginLeft: 14,
  },
});

export default ProfileList;
